import React from 'react';
import { t } from '../../languages';

const TCS = ({ lang }) => {
    return (
        <div>
            <ul>
                <li>
                    <h4>Notificaciones</h4>
                    <p>
                        Al utilizar esta aplicación, el usuario acepta y consiente expresamente el envío de comunicaciones electrónicas con fines relacionados con el uso de la aplicación, tales como: recordatorios para practicar, actualizaciones sobre progresos y logros obtenidos, así como información sobre nuevas funcionalidades o promociones relacionadas con los servicios ofrecidos.
                    </p>

                    <p>
                        Estas comunicaciones pueden realizarse mediante correo electrónico, notificaciones push u otros medios disponibles dentro de la aplicación. El usuario podrá revocar su consentimiento en cualquier momento, siguiendo las instrucciones de baja incluidas en cada comunicación recibida o desde la sección de ajustes de la aplicación.
                    </p>

                    <p>
                        La aplicación garantiza que dichas comunicaciones se realizarán conforme a la normativa vigente en materia de protección de datos y comercio electrónico, respetando siempre la privacidad y preferencias del usuario.
                    </p>
                </li>
            </ul>
        </div>
    )
}
export default TCS;